import React from 'react'; // Removed useState, useCallback
import ServicesListPage from './ServicesListPage'; // Import the correct page component

interface ListPageProps {}

const ListPage: React.FC<ListPageProps> = () => {
  // Removed context consumption as ServicesListView no longer needs it
  // const outletContext = useOutletContext<any>();

  return (
    // ServicesListView no longer takes these props
    <ServicesListPage /> // Render the correct component
  );
};

export default ListPage;
